export default __webpack_public_path__ + "static/media/Monk's Armbands of the Eighteen Pits.ed27bd22.jpg";